import { FC } from 'react';

import { HStack, Icon, Paragraph, VStack } from '@eluve/components';

export const MicrophoneNoAudioDetected: FC<{ compact?: boolean }> = ({
  compact,
}) => {
  if (compact) {
    return (
      <HStack
        gap={3}
        align="center"
        justify="between"
        className="rounded-lg border border-border-primary bg-bg-tertiary px-3 py-2.5"
      >
        <div className="text-text-primary">
          <Icon name="Mic" size="xs" />
        </div>
        <HStack align="center" wFull={false}>
          <div className="rounded-full bg-bg-warning-strong-primary p-0.5 text-text-warning-strong">
            <Icon name="AlertCircle" size="xs" />
          </div>
          <Paragraph color="tertiary" size="sm" weight="medium">
            Audio not detected.
          </Paragraph>
        </HStack>
      </HStack>
    );
  }

  return (
    <VStack
      align="center"
      className="rounded-lg border border-border-primary bg-bg-tertiary p-8 pt-[3.375rem]"
      gap={6}
    >
      <div className="relative grid place-items-center rounded-full bg-bg-strong-secondary p-4 text-text-strong">
        <Icon name="Mic" size="md" />
        <div className="absolute -bottom-1 -left-1 rounded-full bg-bg-warning-strong-primary p-px text-text-warning-strong">
          <Icon name="AlertCircle" size="sm" />
        </div>
      </div>
      <Paragraph
        className="max-w-60 text-center"
        color="tertiary"
        size="sm"
        weight="medium"
      >
        Audio not detected. Please select a different audio source to start.
      </Paragraph>
    </VStack>
  );
};
